import Symbol from "./Symbol";
import { INSPECTOR_VFD } from "../../../constants/inspectorConstants";

class Vfd extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("Vfd", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            powerCurrent: { isVisible: false, value: null, label: "Potencia Nominal" },
            voltageCurrent: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente Nominal" },
            serviceFactor: { isVisible: false, value: null, label: "Factor de Servicio" },
            reactorOnline: { isVisible: false, value: null, label: "Reactor en Línea" },
        };                
    }

    getInspector() {
        return INSPECTOR_VFD;
    }
}

export default Vfd;
